import { RESUME_DRAFT_LEGACY } from '@confluence/named-routes/entry-points/routes.ts';
import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context.ts';

import type { ContentMetadata } from './ContentMetadata.types.ts';

export const getDraftShareIdFromCreateContentMetadata = (data: ContentMetadata): string => {
	const context = data?._links?.context || CONTEXT_PATH;
	const legacyUrl = data?._links?.editui || '';

	const legacyDraftRouteMatch = RESUME_DRAFT_LEGACY.match(context + legacyUrl);
	const id = legacyDraftRouteMatch?.query?.draftShareId;

	const draftShareId = Array.isArray(id) ? id[0] : id;
	return draftShareId || '';
};
